module.exports = __webpack_public_path__ + "img/help-active.7281f8e8.svg";